module.exports = __webpack_public_path__ + "static/media/gram2.e0c0e643.jpg";